export const getLogRocketAppId = () => process.env.REACT_APP_LOGROCKET_KEY;
export const isLogRocketActive = Boolean(getLogRocketAppId());
